// import { createTheme } from "@mui/material";
// import { mainStyle } from "./mainstyle";

export const textStyle = {};

// // export const theme = createTheme({
// //   ...mainStyle,
// //   typography: {
// //     allVariants: {
// //       textAlign: "center",
// //       ...textStyle,
// //     },
// //   },
// // });
